export var colors = {
  aquaMarine: "#32bdd9",
  softBlue: "#618feb",
  blackAlpha50: "rgba(0, 0, 0, 0.03)",
  blackAlpha100: "rgba(0, 0, 0, 0.06)",
  blackAlpha200: "rgba(0, 0, 0, 0.12)",
  blackAlpha300: "rgba(0, 0, 0, 0.24)",
  blackAlpha400: "rgba(0, 0, 0, 0.4)",
  blackAlpha500: "rgba(0, 0, 0, 0.56)",
  blackAlpha700: "rgba(0, 0, 0, 0.74)",
  blackAlpha800: "rgba(0, 0, 0, 0.84)",
  blue100: "#a8e7f0",
  blue200: "#76d9e8",
  blue300: "#4dcce3",
  blue400: "#21bddb",
  blue500: "#00aed1",
  blue600: "#0095c2",
  blue700: "#0181b0",
  blueBright100: "#93f1ff",
  blueBright200: "#60e1f7",
  blueBright400: "#08c5e7",
  blueBright700: "#0081c2",
  gray25: "#fafafa",
  gray50: "#f5f5f5",
  gray100: "#eeeeee",
  gray200: "#e0e0e0",
  gray300: "#cccccc",
  gray400: "#9e9e9e",
  gray500: "#757575",
  gray600: "#5c5c5c",
  gray700: "#424242",
  gray800: "#292929",
  green100: "#d1f3a3",
  green200: "#b5ec86",
  green300: "#95de68",
  green400: "#83d459",
  green500: "#6cc644",
  green600: "#3fad1c",
  green700: "#018f19",
  greenBright100: "#d7ff70",
  greenBright200: "#b2fa55",
  greenBright400: "#81f52e",
  greenBright700: "#0fbd01",
  lavender100: "#c8d1f7",
  lavender200: "#aeb7f5",
  lavender300: "#939df4",
  lavender400: "#7983f2",
  lavender500: "#7372f2",
  lavender600: "#6c61f2",
  lavender700: "#6650f2",
  lavenderBright100: "#b8c1ff",
  lavenderBright200: "#a3a8ff",
  lavenderBright400: "#7a78ff",
  lavenderBright700: "#6836ff",
  orange100: "#ffe2a7",
  orange200: "#ffd68e",
  orange300: "#fcbf5c",
  orange400: "#fdae2c",
  orange500: "#faa415",
  orange600: "#e88809",
  orange700: "#d16900",
  orangeBright100: "#ffe570",
  orangeBright200: "#ffd95c",
  orangeBright400: "#ffbc12",
  orangeBright700: "#f07801",
  pink100: "#f7cde6",
  pink200: "#fab1d8",
  pink300: "#fc90c3",
  pink400: "#f76eab",
  pink500: "#eb4f95",
  pink600: "#d02f82",
  pink700: "#b22076",
  pinkBright100: "#ffccf6",
  pinkBright200: "#ff9cde",
  pinkBright400: "#ff61a8",
  pinkBright700: "#b0007f",
  purple100: "#d9caf8",
  purple200: "#caacf2",
  purple300: "#c090f0",
  purple400: "#be80ed",
  purple500: "#ab6bdb",
  purple600: "#955acc",
  purple700: "#8650bf",
  purpleBright100: "#e2bdff",
  purpleBright200: "#d09bff",
  purpleBright400: "#bc65ff",
  purpleBright700: "#8201e7",
  red100: "#fac8ca",
  red200: "#f79d9e",
  red300: "#f77b74",
  red400: "#f65948",
  red500: "#ed472f",
  red600: "#db2b17",
  red700: "#ca1c07",
  redBright100: "#ffb6ab",
  redBright200: "#ff8a81",
  redBright400: "#fa2f2e",
  redBright700: "#db0024",
  sky100: "#c1dbf5",
  sky200: "#9ac1f5",
  sky300: "#83aef7",
  sky400: "#729df3",
  sky500: "#618feb",
  sky600: "#537ced",
  sky700: "#4a6ae8",
  skyBright100: "#a3dcff",
  skyBright200: "#82c7ff",
  skyBright400: "#5890ff",
  skyBright700: "#3953f9",
  teal100: "#adede0",
  teal200: "#a8e7f0",
  teal300: "#7ee6d8",
  teal400: "#2accc1",
  teal500: "#09bfbc",
  teal600: "#00a8ab",
  teal700: "#00919c",
  tealBright100: "#9cf7e5",
  tealBright200: "#60ebd8",
  tealBright400: "#02dfd8",
  tealBright700: "#00a4b6",
  white: "#ffffff",
  whiteAlpha50: "rgba(255, 255, 255, 0.06)",
  whiteAlpha100: "rgba(255, 255, 255, 0.12)",
  whiteAlpha200: "rgba(255, 255, 255, 0.2)",
  whiteAlpha300: "rgba(255, 255, 255, 0.36)",
  whiteAlpha400: "rgba(255, 255, 255, 0.5)",
  whiteAlpha500: "rgba(255, 255, 255, 0.7)",
  whiteAlpha700: "rgba(255, 255, 255, 0.86)",
  whiteAlpha800: "rgba(255, 255, 255, 1)",
  withAlpha: function withAlpha(color, alpha) {
    var match;
    var r;
    var g;
    var b;
    var a; // eslint-disable-next-line no-cond-assign

    if (match = color.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})?$/i)) {
      r = parseInt(match[1], 16);
      g = parseInt(match[2], 16);
      b = parseInt(match[3], 16);
      a = match[4] ? parseInt(match[4], 16) / 255 : 1.0; // eslint-disable-next-line no-cond-assign
    } else if (match = color.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])?$/i)) {
      r = parseInt(match[1], 16) * 17;
      g = parseInt(match[2], 16) * 17;
      b = parseInt(match[3], 16) * 17;
      a = match[4] ? parseInt(match[4], 16) / 15 : 1.0; // eslint-disable-next-line no-cond-assign
    } else if (match = color.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+)\s*)?\)$/i)) {
      r = parseInt(match[1], 10);
      g = parseInt(match[2], 10);
      b = parseInt(match[3], 10);
      a = match[4] ? parseFloat(match[4]) : 1.0;
    } else {
      throw new Error("Unknown <color> value: ".concat(color));
    }

    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a * alpha, ")");
  }
};
//# sourceMappingURL=colors.js.map